import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  createAccount,
  getAccounts,
  updateAccount,
  deleteAccount,
  type CreateAccountPayload,
  type UpdateAccountPayload,
} from '../api/accounts'
import { toast } from 'sonner'

export const useAccounts = () => {
  return useQuery({
    queryKey: ['accounts'],
    queryFn: getAccounts,
  })
}

export const useCreateAccount = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreateAccountPayload) => createAccount(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['accounts'] })
      queryClient.invalidateQueries({ queryKey: ['dashboardSummary'] })
      queryClient.invalidateQueries({ queryKey: ['transactions'] })
      toast.success('Cuenta creada correctamente')
    },
    onError: () => toast.error('No se pudo crear la cuenta'),
  })
}

export const useUpdateAccount = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: UpdateAccountPayload) => updateAccount(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['accounts'] })
      queryClient.invalidateQueries({ queryKey: ['dashboardSummary'] })
      queryClient.invalidateQueries({ queryKey: ['transactions'] })
      toast.success('Cuenta actualizada correctamente')
    },
    onError: () => toast.error('No se pudo actualizar la cuenta'),
  })
}

export const useDeleteAccount = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => deleteAccount(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['accounts'] })
      queryClient.invalidateQueries({ queryKey: ['dashboardSummary'] })
      queryClient.invalidateQueries({ queryKey: ['transactions'] })
      toast.success('Cuenta desactivada correctamente')
    },
    onError: () => toast.error('No se pudo desactivar la cuenta'),
  })
}

